/* eslint class-methods-use-this: 0 */

const acceptAll = "cookies-accept-all";
const acceptRequired = "cookies-accept-required";
const openSettings = "cookies-open-settings";
const cookiesAccept = "cookies-accept:";
const cookiesDecline = "cookies-decline:";


export default class EventDispatcher {
    acceptAllEventName() { return acceptAll; }

    acceptAll() { this.newEvent(acceptAll); }

    acceptRequiredEventName() { return acceptRequired; }

    acceptRequired() { this.newEvent(acceptRequired); }

    openSettingsEventName() { return openSettings; }

    openSettings() { this.newEvent(openSettings); }

    newEvent(eventName) {
        const event = document.createEvent("Event");
        event.initEvent(eventName, true, false);
        document.dispatchEvent(event);
    }

    acceptCategory(category) { this.newEvent(cookiesAccept + category); }

    acceptCategoryEventName(category) { return cookiesAccept + category; }

    declineCategory(category) { this.newEvent(cookiesDecline + category); }

    declineCategoryEventName(category) { return cookiesDecline + category; }

    addAcceptListener(categoryName, fn) {
        const eventName = this.acceptCategoryEventName(categoryName);
        document.addEventListener(eventName, fn);
    }
}
